/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS, displayDistance } from '../utilities';
import './styles.scss';
import { checkIfValueIsValid, Unit } from '../common';

export const getDistancesData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.DISTANCES;

  const distancesData = dataSet[factKey] || {};

  const DistancesFactsRow = ({ facts }) => {
    const factFieldName = facts?.factFieldName;

    if (checkIfValueIsValid(facts?.value)) {
      const { value, unit } = displayDistance(facts?.value, true);
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {value} <Unit unit={unit} />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const fields = [];

  Object.keys(distancesData).forEach((fieldKey, index) => {
    if (checkIfValueIsValid(distancesData[fieldKey])) {
      fields.push(
        <DistancesFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: distancesData[fieldKey]
          }}
        />
      );
    }
  });

  const DistancesSection = () => {
    return <div className='distances-data-body'>{fields}</div>;
  };

  return {
    component: <DistancesSection />,
    factsCount: 0
  };
};
